/**
 * Makes a call event text string
 * @param {Object} options
 * @param {String} options.type - the type of call
 * @param {String} options.status - the status of call
 * @returns {String} - Call Event
 */
const call = ({ type, status }) => {
  if (type) return `${type}-call`;
  if (status) return `call-${status}`;
};

module.exports = call;
